// extracted by mini-css-extract-plugin
export var startRoundContainer = "StartRound-module--startRoundContainer--1dS3f";
export var playsNow = "StartRound-module--playsNow--wrkk9";
export var movieButton = "StartRound-module--movieButton--3TR2n";
export var selectedMovieButton = "StartRound-module--selectedMovieButton--3lmKc";
export var notSelectedMovieButton = "StartRound-module--notSelectedMovieButton--1tM2L";
export var startRoundButton = "StartRound-module--startRoundButton--2_LBX";
export var backButton = "StartRound-module--backButton--3xDg5";